const en = {
    sale: 'Sales',
    hello: 'Hallo World!',
    save: 'Save',
    reset: 'Reset',
    delete: 'Delete',
    add_user: 'Add User',
    edit_user: 'Edit User',
    go_back: 'back to overview',
    show_ordered_goods: 'Ordered Goods',
    show_stock_items: 'Stock Items',
    loading_error_alert: 'An error occurred while loading the page.',
    id: 'ID',
    name: 'Name',
    description: 'Description',
    define_columns: 'Define Columns',
    search_columns: 'Search Column',
    show_columns: 'Visible',
    hidden_columns: 'Hidden',
    product: 'Product',
    category: 'Category',
    marker_category: 'Marked Categories',
    new_category: 'New Category',
    property: 'Property',
    marker_property: 'Marked Properties',
    new_property: 'New Property',
    propset: 'Propset',
    marker_propset: 'Marked Propsets',
    new_propset: 'New Propset',
    customer: 'Customer',
    marker_customer: 'Marked Customers',
    new_customer: 'New Customer',
    group: 'Customer Group',
    marker_group: 'Marked Customer Groups',
    new_group: 'New Customer Group',
    order: 'Order',
    marker_order: 'Marked Orders',
    new_order: 'New Order',
    content: 'Content',
    marker_content: 'Marked Contents',
    new_content: 'New Content',
    page: 'Page',
    marker_page: 'Marked Pages',
    new_page: 'New Page',
    delivery: 'Delivery',
    marker_delivery: 'Marked Deliveries',
    new_delivery: 'New Delivery',
    supplier: 'Supplier',
    marker_supplier: 'Marked Suppliers',
    new_supplier: 'New Supplier',
    goods_receipt: 'Incoming Goods',
    new_goods_receipt: 'New Incoming Goods',
    marker_goods_receipt: 'Marked Incoming Goods',
    finish_goods_receipt: 'Finish Incoming Goods',
    commission_box: 'Commission Box',
    marker_commission_box: 'Marked Commission Boxes',
    new_commission_box: 'New Commission Box',
    claim: 'Complaint',
    marker_claim: 'Marked Complaints',
    new_claim: 'New Complaint',
    purchase: 'Purchase',

    payed: 'paid',
    Payed: 'Paid',

    '{job} completed': '{job} completed',
    '{job} failed': '{job} failed',

    pagination: {
        nothingFound: 'No records found'
    },

    upload: {
        drop: {
            singular: '<h3>Drag and dop file</h3> or <em>klick here</em> to upload',
            plural: '<h3>Drag and drop files</h3> or <em>click here</em> to upload'
        },
        notUploaded: 'File could not be upload!',
        sizeExceeded: 'File size exceeded!',
        max: 'Max. {size}',
        validation: '{filetypes} files not larger than {size} are allowed'
    },

    section: {
        add: {
            drop: 'add <span class="highlight">{section}</span> here',
            click: 'Click here to add <span class="highlight">{section}</span>',
            hint: 'Click to insert or drag & drop to position'
        },
        paste: {
            click: 'Click here to paste <span class="highlight">{section}</span>'
        },
        search: {
            no_results: 'No results for "{query}"'
        }
    },
    pdf: {
        stockReportCreated: 'PDF article stock created successfully.',
        inventoryProtocolCreated: 'PDF inventory protocol created successfully.'
    },
    payment_reason: {
        insufficient_funds: 'Insufficient funds',
        account_closed: 'Account closed',
        bank_account_restricted: 'Direct debits blocked on the account',
        debit_not_authorized: 'Debit not authorized, no mandate',
        authorization_revoked: 'Mandate revoked',
        debit_disputed: 'Reclaimed by the customer at their bank',
        debit_authorization_not_match: 'Mandate details do not match',
        invalid_account_number: 'Invalid IBAN',
        incorrect_account_holder_name: 'Account holder does not match',
        branch_does_not_exist: 'Bank branch does not exist',
        recipient_deceased: 'Account holder deceased',
        refer_to_customer: 'No reason from the bank, ask the customer',
        generic_could_not_process: 'The bank could not process it',
        processing_error: 'Processing error',
        try_again_later: 'Try again later',
        card_declined: 'Card declined',
        expired_card: 'Card expired',
        general: 'No reason given',
        fraudulent: 'Reported as fraudulent',
        bank_cannot_process: 'The bank could not process it',
        customer_initiated: 'Initiated by the customer',
        lost: 'Lost for good',
        won: 'Decided in our favour',
        lost_or_stolen_card: 'Card blocked',
        expired_or_canceled_card: 'Card expired or cancelled',
        unknown: 'Reason unknown',
        canceled: 'Canceled',
        warning_closed: 'Inquiry closed without a dispute',
        charge_refunded: 'Already refunded',
        check_returned: 'Check returned',
        credit_not_processed: 'Credit not processed',
        duplicate: 'Duplicate charge',
        incorrect_account_details: 'Incorrect account details',
        product_not_received: 'Service not received',
        product_unacceptable: 'Service unacceptable',
        subscription_canceled: 'Subscription cancelled',
        unrecognized: 'Charge not recognised',
        charge_for_pending_refund_disputed: 'Charge disputed while the refund was pending',
        declined: 'Declined by the bank',
        merchant_request: 'At our request',
    },
    payment_event: {
        payment_failed: 'Debit rejected',
        payment_canceled: 'Payment canceled',
        dispute_created: 'Reclaimed by the customer',
        dispute_closed: 'Dispute closed',
        dispute_funds_withdrawn: 'Amount withheld',
        dispute_funds_reinstated: 'Amount reinstated',
        refunded: 'Refunded',
        refund_failed: 'Refund failed',
    },
    // A ticket's status, the ONE set of labels for every ticket surface
    // (TICKET_STATUS_KEYS in extensions/tickets/ticketStatus.js).
    ticket_status: {
        'new': 'New',
        'estimate-effort': 'Estimate effort',
        'in-progress': 'In progress',
        'pending': 'Awaiting feedback',
        'on-hold': 'On hold',
        'completed': 'Completed',
        'not-reproducible': 'Not reproducible',
        'closed': 'Closed',
    },
    invoice_status: {
        draft: 'Draft',
        pending: 'Awaiting payment',
        paid: 'Paid',
        failed: 'Payment failed',
        cancelled: 'Cancelled',
        disputed: 'Reclaimed by the customer',
        refunded: 'Refunded',
    },
}

export default en
